var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.69678C6.5 2.69678 2 7.18678 2 12.7168C2 17.7168 5.66 21.8668 10.44 22.6168V15.6168H7.9V12.7168H10.44V10.5068C10.44 7.99678 11.93 6.61678 14.22 6.61678C15.31 6.61678 16.45 6.80678 16.45 6.80678V9.27678H15.19C13.95 9.27678 13.56 10.0468 13.56 10.8368V12.7168H16.34L15.89 15.6168H13.56V22.6168C15.9164 22.2446 18.0622 21.0423 19.6099 19.2268C21.1576 17.4114 22.0054 15.1024 22 12.7168C22 7.18678 17.5 2.69678 12 2.69678Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFacebook);
export default __webpack_public_path__ + "static/media/logo-facebook.4f8480dc2644adbb846de025d7d1b532.svg";
export { ForwardRef as ReactComponent };